export const Positions = [
  {
    id: 1,
    category: "Software Development",
    title: "Product Designer",
    description: "We're looking for a mid-level product designer to join our team.",
    type: "Full-time",
    salary: "80k - 100k",
    role: "Software Engineer",
    location: "Softations, Output, Full-time, Remote",
    aboutCompany: "At Softations, our technology solves complex problems and enriches lives. We're an established leader in developing a culture of innovative solutions, dedicated to pushing the boundaries of what's possible in the Tech sector. We foster a culture of forward-thinking collaboration and continuously elevate our solutions, delivering cutting-edge applications that exceed our industry standards, making the world a better place to be and achieve our 'mission.'",
    opportunity: "We are seeking a highly skilled and motivated Software Engineer to join our product and network design team. Ideal candidates will have a strong command of software development processes and be enthusiastic about fixing technical issues and fixing them from methodical engineering. You will play a key role in designing, building, and delivering software solutions, contributing directly to products that impact millions of users.",
    whatYouDo: [
      "Collaborate with cross-functional teams (Product, Design, QA) to define, design, and ship new features.",
      "Write clean, scalable, maintainable, and performant code in [Primary Language, e.g., Python, Java].",
      "Develop and maintain RESTful APIs and microservices with a high reliability and performance.",
      "Troubleshoot, debug, and upgrade existing software to ensure optimal performance.",
      "Participate in code reviews, providing and receiving constructive feedback.",
      "Ensure the technical feasibility of UI/UX designs and improve application functionality."
    ],
    requiredSkills: [
      "Bachelor's Degree in Computer Science, Engineering, or a related field (or equivalent experience).",
      "[Minimum] years of professional software engineering experience in an industry setting.",
      "Strong proficiency in [Primary Programming Language] and familiarity with object-oriented design principles.",
      "Solid experience with databases, including writing stored procedures, functions, and views for relational (e.g., PostgreSQL, MySQL) or NoSQL platforms.",
      "Experience with front-end technologies (e.g., React, JavaScript, HTML, CSS) or specific frameworks.",
      "Experience with cloud platforms such as AWS, Google Cloud, or Azure.",
      "Knowledge of testing frameworks and tools for web or mobile applications.",
      "Experience working with distributed systems and/or microservices architecture."
    ],
    desiredQualifications: [
      "Excellent problem-solving skills, attention to detail, and strong written and verbal communication abilities.",
      "A proactive, self-motivated team player."
    ],
    benefits: [
      "Competitive salary and performance bonuses.",
      "Comprehensive health, dental, and vision insurance.",
      "HRA/Hybrid/Provident Fund.",
      "Flexible remote work options.",
      "Opportunities for professional development and career growth."
    ]
  }
];